module.exports = __webpack_public_path__ + "static/media/56_s3_cam005_small.d4c4741e.jpg";